/**
 * @name WelcomePassword
 * @description Componente para crear o cambiar contraseña desde el correo de bienvenida o solicitud de cambio de contraseña
 * @author Ricardo Guerra
 */

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import i18n from 'i18next';

import { Lines, PasswordForm } from '@components';
import { PasswordService, ResponseHandlerService, SnackbarService } from '@services';
import { Layout, MUI, Typography } from '@styles';

class WelcomePassword extends Component {
  constructor(props) {
    super(props);
    let URLParams = `${props.location.search}${props.location.hash}`;
    let queryParams = new URLSearchParams(URLParams);

    this.state = {
      userId: queryParams.get('idUsuario'),
      user: queryParams.get('usuario'),
      token: encodeURIComponent(queryParams.get('token')),
      firstTime: props.location.pathname === '/bienvenida',
    };
  }

  configPassword = (values, setSubmitting) => {
    const { userId, token } = this.state;
    const { history } = this.props;

    if (userId && token) {
      PasswordService.restore({
        IdUsuario: userId,
        Token: token,
        ContraseñaNueva: values.newPassword,
        ConfirmarContraseña: values.confirmPassword
      }).then((response) => {
        ResponseHandlerService.success(response);
        history.push('/login');
      }).catch((error) => {
        setSubmitting(false);
        ResponseHandlerService.error(error);
      });
    } else {
      setSubmitting(false);
      SnackbarService.error(i18n.t('ChangePass.errorToChangePass'));
    }
  }

  render() {
    const { firstTime, user } = this.state;
    return (
      <>
        <Layout.ContentWrapper>
          <MUI.Box margin="16px">
            {firstTime ? (
              <Typography.H2>
                {i18n.t('GenericMessages.welcomeTalentry')}
              </Typography.H2>
            ) : (
                <Typography.H2>
                  {i18n.t('ChangePass.changePass')}
                </Typography.H2>
              )}
          </MUI.Box>
          <MUI.Box margin="16px">
            <Lines
              direction="horizontal"
              firstLine={{ size: 75, color: 'blueMedium' }}
              secondLine={{ size: 25, color: 'red' }}
            />
          </MUI.Box>
          <PasswordForm
            user={user}
            changePassword={!firstTime}
            retrievePassword={true}
            onConfigPassword={this.configPassword}
          />
        </Layout.ContentWrapper>
      </>
    );
  }
}

WelcomePassword.propTypes = {
  location: PropTypes.object,
  history: PropTypes.object
};

export default WelcomePassword;
